import { NativeSelect } from '@/components/ui/native-select'
import { isLawyerLike } from '@/lib/roles'
import type { TeamMember } from '@/services/team-service'

interface LawyerSelectorProps {
  value: string
  members: TeamMember[]
  currentUserId?: string
  onChange: (value: string) => void
}

/** Seletor de advogado da caixa de entrada: Todos, Eu e cada colega (sócios e advogados). */
export function LawyerSelector({ value, members, currentUserId, onChange }: LawyerSelectorProps) {
  const colleagues = members.filter((m) => m.id !== currentUserId && isLawyerLike(m.role))
  return (
    <div className="w-full sm:w-56">
      <NativeSelect aria-label="Advogado" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="todos">Todos os advogados</option>
        <option value="eu">Eu</option>
        {colleagues.map((member) => (
          <option key={member.id} value={member.id}>
            {member.fullName || member.email}
          </option>
        ))}
      </NativeSelect>
    </div>
  )
}
